import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { HeroSliderProps } from "./types";
import {
    EntryOptions,
    PropertyDefinition,
    PropertyMappingType,
} from "app/library/layout-builder";
import { MetaTypeEnum } from "app/shared";

import { CardPropertyDefinitions, ImageChildrenDefinitions, VideoChildrenDefinitions, SlideshowDefinition } from 'components/cms/definitions';

export class HeroSliderDefinitions extends CmsReactComponent<HeroSliderProps> {
    static schemaName = "hero-slider";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "slides",
            text: "Slayt",
            description: "Slayt sayfaları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: [{
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "title",
                    text: "Slayt Başlığı",
                },
                {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "subtitle",
                    text: "Slayt Alt Başlığı",
                },
                {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "artistTitle",
                    text: "Besteci Adı",
                },
                {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "establishmentTitle",
                    text: "Kurum Adı",
                },
                {
                    mapping: {
                        type: PropertyMappingType.Boolean,
                    },
                    name: "isCapitalize",
                    text: "İlk harfi büyük olarak kullanılsın mı?",
                }, {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "type",
                    text: "Slayt Tipi",
                }, {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "datetimeString",
                    text: "Büyük Tarih Metni",
                }, {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "datetime",
                    text: "Standart Tarih Metni",
                }, {
                    mapping: {
                        type: PropertyMappingType.ParentObject,
                        children: ImageChildrenDefinitions,
                    },
                    name: "image",
                    text: "Slayt Resmi",
                }, {
                    mapping: {
                        type: PropertyMappingType.ParentObject,
                        children: ImageChildrenDefinitions,
                    },
                    name: "mobileImage",
                    text: "Mobile Slayt Resmi",
                }, {
                    mapping: {
                        type: PropertyMappingType.ParentObject,
                        children: VideoChildrenDefinitions,
                    },
                    name: "video",
                    text: "Slayt Video",
                }, {
                    mapping: {
                        type: PropertyMappingType.ParentObject,
                        children: VideoChildrenDefinitions,
                    },
                    name: "mobileVideo",
                    text: "Mobile Slayt Video",
                }, {
                    mapping: {
                        type: PropertyMappingType.LinkWizard,
                    },
                    name: "anchor",
                    text: "Slayt Linki",
                }, {
                    mapping: {
                        type: PropertyMappingType.String,
                    },
                    name: "className",
                    text: "Özel sınıf",
                },
                ],
            },
            group: {
                key: "data",
                title: "Slayt Verileri",
                withObject: false,
            }
        },
        {
            name: "announcements",
            description: "Announcement List Elemanları",
            mapping: {
                type: PropertyMappingType.ArrayData,
                keys: CardPropertyDefinitions,
            },
            group: {
                key: "data",
                title: "Announcement Verileri",
                withObject: false,
            }
        },
        {
            mapping: {
                type: PropertyMappingType.Html,
            },
            name: "ticket",
            text: "Biletlendirme açıklaması",
        },

        {
            mapping: {
                type: PropertyMappingType.File,
            },
            name: "monthlyNewsletter",
            description: "Aylık bülten dosyası seçiniz",
            text: "Aylık Bülten",
        },
        {
            mapping: {
                type: PropertyMappingType.File,
            },
            name: "monthlyNewsletter",
            description: "Aylık bülten dosyası seçiniz",
            text: "Aylık Bülten",
        },
        {
            name: "settings",
            text: "Ayarlar",
            description: "Slayt Ayarları",
            mapping: {
                type: PropertyMappingType.ParentObject,
                children: SlideshowDefinition,
            },
            group: {
                key: "slider",
                title: "Slayt Ayarları",
                withObject: true,
            }
        },
        {
            name: "width",
            text: "Genişlik",
            description: "Kart Görsel Genişliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
        {
            name: "height",
            text: "Yükseklik",
            description: "Kart Görsel Yüksekliği",
            mapping: {
                type: PropertyMappingType.Number
            }
        },
    ];

    static options: EntryOptions = {
        meta: {
            use: false,
            allowedTypes: []
        },
        mappingFields: [
            {
                name: "title",
                text: "Slayt Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "subtitle",
                text: "Slayt Alt Başlık",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "artistTitle",
                text: "Besteci Adı",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "establishmentTitle",
                text: "Kurum Adı",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "type",
                text: "Slayt Tipi",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "datetimeString",
                text: "Tarih Metni Büyük",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "datetime",
                text: "Tarih Metni",
                types: [MetaTypeEnum.Text],
            },
            {
                name: "image",
                text: "Slayt Görsel",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "mobileImage",
                text: "Mobile Slayt Görsel",
                types: [MetaTypeEnum.SingleImage],
            },
            {
                name: "video",
                text: "Slayt Video",
                types: [MetaTypeEnum.SingleVideo],
            },
            {
                name: "anchor",
                text: "Slayt URL",
                types: [MetaTypeEnum.Link]
            },
            {
                name: "isCapitalize",
                text: "İlk Harf Büyük Olarak Kullanılsın Mı?",
                types: [MetaTypeEnum.Checkbox],
            },

            {
                name: "description",
                text: "Duyuru Açıklaması",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea],
            },
            {
                name: "content",
                text: "Duyuru İçeriği",
                types: [MetaTypeEnum.Text, MetaTypeEnum.TextArea, MetaTypeEnum.Editor],
            },

        ],
    };
}
